import installationInstructions from './installationInstructions';

const viewContent = {
  installationInstructions
}

export { viewContent };